<div class="chatPanel-body" aria-live="polite">
  <ul class="chatPanel-content">
    <li
      class="chatPanel-element"
      id="{{ msgId(indexOfElement) }}"
      *ngFor="let message of messages; let indexOfElement = index"
      [ngClass]="message.direction + (message.copyGuest ? ' copy-element' : '')"
    >
      <ng-container *ngIf="!message.copyGuest || !message.copyGuest.isFullCopy">
        <div class="chatPanel-element-header">
          <p>
            <span class="nodisplay">Message de</span>
            <ng-container *ngIf="!isFromUnknownContact(message)">
              {{ message.from.firstName }}
              {{ message.from.lastName }}
            </ng-container>
            <ng-container *ngIf="isFromUnknownContact(message)">
              {{ 'commons:chat.unknown_contact' | translate }}
            </ng-container>
          </p>
          <time>
            <span class="nodisplay">à</span>
            {{ message.timestamp | localizedDate: 'shortTime' }}
          </time>
        </div>
        <div class="chatPanel-element-content">
          <p [innerHTML]="getMessageContent(message.content)"></p>
        </div>
      </ng-container>

      <ng-container *ngIf="message.copyGuest && message.copyGuest.isFullCopy">
        <div class="copy-message-list">
          <chat-copy-list [copyMessages]="copyMessages.get(message.copyGuest.copyKey)"></chat-copy-list>
        </div>
      </ng-container>
    </li>
  </ul>
</div>
<div class="action-buttons">
  <div title="{{ 'commons:chat.add_participant' | i18next }}">
    <button mat-icon-button class="icon cng-ico_conf3" (click)="addGuestToRoom()"></button>
  </div>
  <div title="{{ 'commons:chat.clean_conversation' | i18next }}">
    <button
      mat-icon-button
      class="icon cng-ico_erase"
      [ngClass]="messages.length === 0 ? 'empty-conversation' : ''"
      [disabled]="messages.length === 0"
      (click)="emptyConversation()"
    ></button>
  </div>
  <div title="{{ 'commons:chat.close_conversation' | i18next }}">
    <button mat-icon-button class="icon cng-ico_annuler" (click)="closeRoom()"></button>
  </div>
</div>
<div class="chatPanel-footer cng-dark-contrast">
  <mat-form-field>
    <mat-label>{{ 'commons:chat.message' | translate }}</mat-label>
    <textarea
      matInput
      cdkTextareaAutosize
      cdkAutosizeMinRows="1"
      cdkAutosizeMaxRows="5"
      [(ngModel)]="messageToSend"
      (keypress)="onKeyPressed($event)"
    ></textarea>
  </mat-form-field>
  <div title="{{ 'commons:chat.send-button_a11y' | translate }}">
    <button matRipple class="send-button" (click)="sendMessage()" [disabled]="messageToSend.length <= 0">
      <span class="icon cng-ico_chat_envoi" aria-hidden></span>
      <span class="button-label" aria-hidden>
        {{ 'commons:chat.send-button' | translate }}
      </span>
      <span class="nodisplay">
        {{ 'commons:chat.send-button_a11y' | translate }}
      </span>
    </button>
  </div>
</div>
